import { render, staticRenderFns } from "./Cont.vue?vue&type=template&id=128b89fa"
import script from "@/controllers/ap/announcement/Cont?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/announcement/Cont?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports